module.exports = __webpack_public_path__ + "img/secure-off-fill.aeee85d0.svg";